import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getLeaseDealsValueRating } from 'client/site-modules/lease-deals/utils/get-lease-deals-value-rating';
import { RATING_DESCRIPTIONS } from './payment-ratio-insights-utils';

const RATING_LABELS_LOWERCASE = {
  1: 'poor',
  2: 'below average',
  3: 'typical',
  4: 'good',
  5: 'excellent',
};

const RATING_COLOR_CLASS_MAP = {
  1: 'text-orange-30',
  2: 'text-blue-50',
  3: 'text-blue-50',
  4: 'text-green-50',
  5: 'text-green-50',
};

export function PaymentRatioInsightsText({ effectivePaymentRatio, className = null }) {
  const { rating } = getLeaseDealsValueRating(effectivePaymentRatio);

  const ratingLabel = RATING_LABELS_LOWERCASE[rating];
  const article = /^[aeiou]/i.test(ratingLabel) ? 'an' : 'a';

  return (
    <div className={classNames('payment-ratio-insights', className)}>
      <p className="size-20 fw-bold text-cool-gray-30 mb-0_5">
        This is {article} <span className={RATING_COLOR_CLASS_MAP[rating]}>{ratingLabel}</span> lease deal
      </p>
      <p className="size-16 text-cool-gray-30 m-0">{RATING_DESCRIPTIONS[rating]}</p>
    </div>
  );
}

PaymentRatioInsightsText.propTypes = {
  effectivePaymentRatio: PropTypes.number.isRequired,
  className: PropTypes.string,
};
